import { useState } from 'react';
import {
  Avatar,
  Box,
  ListItem,
  ListItemButton,
  Menu,
  MenuItem,
  Divider,
  Typography,
  useTheme,
  Stack,
} from '@mui/material';

import ThreeDotsIcon from '../icons/ThreeDotsIcon';
import SignOutIcon from '../icons/SignOutIcon';
import { useLocalization } from 'localization';
import { useAuth } from 'modules/auth/hooks';
import ManageAccountIcon from '../icons/ManageAccountIcon';
import useAppNavigation from 'hooks/general/useAppNavigation';
import routes from 'app.routes';
import { userStore } from 'stores/userStore';

type Props = {
  isSidebarClosed: boolean;
};

const UserProfileBottomBar = (props: Props) => {
  const { isSidebarClosed } = props;
  const { t } = useLocalization();
  const theme = useTheme();
  const { softLogout } = useAuth();
  const { navigateTo } = useAppNavigation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const { user } = userStore();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = () => {
    navigateTo(routes.v2.accountSettings.overview);
    handleClose();
  };

  return (
    <>
      <ListItem disablePadding={!isSidebarClosed}>
        <ListItemButton
          sx={{
            borderRadius: 1,
            justifyContent: isSidebarClosed ? 'center' : 'space-between',
            px: 0.5,
            py: 1,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
          onClick={handleClick}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              alt={user?._dto?.firstName}
              src={'none'}
              sx={{
                width: 28,
                height: 28,
                mr: isSidebarClosed ? 0 : 1.5,
                border: `1px solid ${theme.palette.divider}`,
              }}
            />
            {!isSidebarClosed && (
              <Typography
                variant="body1"
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '12ch',
                }}
              >
                {user?._dto?.email.split('@')[0]}
              </Typography>
            )}
          </Box>
          {!isSidebarClosed && <ThreeDotsIcon />}
        </ListItemButton>
      </ListItem>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: {
            sx: {
              minWidth: '13rem',
            },
          },
        }}
      >
        <MenuItem>
          <Stack alignItems="center" direction="row" justifyContent="space-between" gap={1} onClick={handleNavigation}>
            <ManageAccountIcon width={24} height={24} />
            <Typography variant="body1">{t('navigation.secondaryMenu.accountSetting')}</Typography>
          </Stack>
        </MenuItem>
        <Divider sx={{ m: 2 }} />
        <MenuItem onClick={softLogout}>
          <Stack alignItems="center" direction="row" justifyContent="space-between" gap={1}>
            <SignOutIcon />
            <Typography variant="body1">{t('navigation.mainMenu.logout')}</Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserProfileBottomBar;
